import { useEffect } from 'react';
import { Formik } from 'formik';
import { Button, Col, Form, Row } from "react-bootstrap";
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';
import i18next from 'i18next';
import { LeadCallResponseEnum, LeadsModalModeEnum } from '../../../../api/models/Enums';
import { useApiClient } from '../../../../hooks/useApiClient';
import { LeadCallRequestDTO } from '../../../../api';
import useLeadsStore from '../../../../store/LeadsStore'
import useModalStore from '../../../../store/ModalStore';
import toaster from '../../../../utils/toaster'
import { useMutation, useQueryClient } from "@tanstack/react-query";

const LeadPhoneCallMessage = () => {
  const { t } = useTranslation()
  const { apiClient } = useApiClient();
  const { openModal, closeModal, modalState } = useModalStore();
  const { activeLead } = useLeadsStore();
  const queryClient = useQueryClient();

  const validationSchema = Yup.object().shape({
    message: Yup.string().required(i18next.t('name_mandatory')),
  });

  const {isPending, mutate} = useMutation({
    mutationFn: (payload: LeadCallRequestDTO) => apiClient.leadsControllerService.recordCall(payload),
    onSuccess: (data) => {
      toaster.success(i18next.t('call_no_reply_recorded_successfully'));
      queryClient.invalidateQueries({ queryKey: ["lead_calls_log"] });
      closeModal()
    },
    onError: (error) => {
      console.error("Error recording call no reply:", error);
      toaster.error(i18next.t('call_no_reply_recorded_successfully'));
    },
  });

  const handleFormSubmit = (values: { message: string }) => {
    let esitoChiamata = ''
    if (modalState.mode === LeadsModalModeEnum.PHONE_CALL_NO_REPLY) {
      esitoChiamata = LeadCallResponseEnum.NO_ANSWER
    }

    mutate({
      LeadId: activeLead.Id,
      Esito_chiamata__c: esitoChiamata,
      Description: values.message
    });
  }

  const initialValues: { message: string } = {
    message: '',
  };

  useEffect(() => {
    return () => {
      openModal(LeadsModalModeEnum.DETAILS);
    }
  }, []);

  return (
    <Formik
      initialValues={initialValues}
      // validationSchema={validationSchema}
      onSubmit={handleFormSubmit}
      enableReinitialize={true}
    >
      {({ values, errors, touched, handleChange, handleSubmit }) => (
        <Form onSubmit={handleSubmit}>
          <Row>
            <Col sm={12}>
              <Form.Group className="mb-3">
                <Form.Label>{t('message')}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="message"
                  onChange={handleChange}
                  value={values.message || ""}
                  isInvalid={!!errors.message && touched.message}
                />
                {/* {touched.message && errors.message ? (
                  <div style={{ color: 'red' }}>{errors.message}</div>
                ) : null} */}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col md={12} className='d-flex justify-content-end'>
              <Button
                variant="primary"
                type="submit"
                className='me-2'
                disabled={isPending}
              >
                {t('save')}
              </Button>
{/*
              <Button onClick={closeModal}>
                <SpinnerButton
                  label={i18next.t("close")}
                />
              </Button> */}
            </Col>
          </Row>
        </Form>
      )}
    </Formik>




  )
}

export default LeadPhoneCallMessage
